import React from "react";
import { useBilling } from "../../store/BillingContext";

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useBilling();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" style={{
      position: "fixed",
      bottom: "24px",
      right: "24px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      zIndex: 9999,
      maxWidth: "360px",
      pointerEvents: "none"
    }}>
      {toasts.map((toast) => {
        const bg =
          toast.type === "error"
            ? "#dc2626"
            : toast.type === "warning"
            ? "#d97706"
            : toast.type === "info"
            ? "#0284c7"
            : "#15803d";

        const icon =
          toast.type === "error"
            ? "fa-triangle-exclamation"
            : toast.type === "warning"
            ? "fa-circle-exclamation"
            : toast.type === "info"
            ? "fa-circle-info"
            : "fa-circle-check";

        return (
          <div
            key={toast.id}
            style={{
              background: bg,
              color: "#ffffff",
              borderRadius: "10px",
              padding: "14px 18px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              pointerEvents: "auto",
              transition: "all 0.2s ease"
            }}
          >
            <i className={`fa-solid ${icon}`} style={{ marginTop: "2px", fontSize: "16px" }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: "13px" }}>{toast.title}</div>
              {toast.message && (
                <div style={{ fontSize: "12px", opacity: 0.9, marginTop: "2px" }}>
                  {toast.message}
                </div>
              )}
            </div>
            <button
              onClick={() => removeToast(toast.id)}
              style={{
                background: "transparent",
                border: "none",
                color: "#ffffff",
                padding: "2px 4px",
                cursor: "pointer",
                fontSize: "14px",
                opacity: 0.75
              }}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
};
